/**
 * MSAL Configuration for Azure AD Authentication
 */

import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL configuration
// Dynamically set redirect URI based on current URL
const getRedirectUri = () => {
  // Use environment variable if set, otherwise use current origin
  if (import.meta.env.VITE_REDIRECT_URI) {
    return import.meta.env.VITE_REDIRECT_URI;
  }
  // Use the current page's origin
  return window.location.origin;
};

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || ''}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true, // Changed to true - navigate back to the page that initiated login
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  }
};

// Add scopes for the API you want to access
// Include the backend API scope upfront so MSAL caches the token on first login
// and acquireTokenSilent succeeds without a second redirect
export const loginRequest: PopupRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    '5a2cbee4-2bbf-4650-9518-a7304cdf4e69/.default'
  ],
};

// Token request for API calls - requests backend API scope with app roles
export const tokenRequest = {
  scopes: [
    '5a2cbee4-2bbf-4650-9518-a7304cdf4e69/.default'  // Backend API scope - includes app roles (Survey.Admin, etc.)
  ],
};
